import { fetcher } from '@commenda/utils';

type BulkAssignCompliancesToUsersProp = {
  complianceItemIds: string[];
  assigneeIdsToAdd?: string[];
  assigneeIdsToRemove?: string[];
  companyId: number;
};

export async function bulkAssignCompliancesToUsers(
  body: BulkAssignCompliancesToUsersProp
): Promise<Response | null> {
  const res = fetcher(`compliance/bulk/assignees`, {
    method: 'POST',
    body,
  });

  return res;
}
